import React from 'react';
import { NavLink } from 'react-router-dom';
import { formatUnits } from 'ethers';
import { useWallet } from '../../context/WalletContext';
import { useAdminRole } from '../../hooks/useAdminRole';
import { usePlanConfig } from '../../hooks/usePlanConfig';
import { useSwapHighlight } from '../../hooks/useSwapHighlight';
import NeonButton from '../common/NeonButton';
import WalletChip from '../wallet/WalletChip';
import Icon from '../common/Icon';

const NAV_TABS = [
  { to: '/',       label: 'Home',   icon: 'home',   exact: true },
  { to: '/invest', label: 'Invest', icon: 'invest' },
  { to: '/team',   label: 'Team',   icon: 'team' },
  { to: '/ranks',  label: 'Rank',   icon: 'rank' },
  { to: '/swap',   label: 'Swap',   icon: 'swap' },
];

const Header = () => {
  const { account, connectInjected, connecting } = useWallet();
  const { config } = usePlanConfig();
  const role = useAdminRole();
  const swapGlow = useSwapHighlight();

  let priceStr = '—';
  if (config && config.grxPriceUSDT) {
    try {
      const n = parseFloat(formatUnits(config.grxPriceUSDT.toString(), 18));
      priceStr = '$' + n.toFixed(6);
    } catch {}
  }

  return (
    <header className="app-header">
      <div className="header-brand-desktop">
        <img src="/Logo.png" alt="Graphenex" className="animate-breathe" />
        <span className="brand-text grx-text-gradient">GRAPHENEX</span>
      </div>

      <div className="header-brand-mobile">
        <img className="brand-mark animate-breathe" src="/Logo.png" alt="Graphenex" />
        <span className="brand-text grx-text-gradient">GRAPHENEX</span>
      </div>

      <nav className="top-nav">
        {NAV_TABS.map((t) => {
          const extra = (t.to === '/swap' && swapGlow) ? ' highlighted' : '';
          return (
            <NavLink key={t.to} to={t.to} end={t.exact}
              className={({ isActive }) => 'tn-item' + (isActive ? ' active' : '') + extra}>
              <Icon name={t.icon} size={18} />
              <span>{t.label}</span>
            </NavLink>
          );
        })}
        {role.isPrivileged && (
          <NavLink to="/admin" className={({ isActive }) => 'tn-item' + (isActive ? ' active' : '')}>
            <Icon name="admin" size={18} />
            <span>Admin</span>
          </NavLink>
        )}
      </nav>

      <div className="header-right">
        <div className="price-ticker">
          <span className="dot" />
          <span style={{ color: 'var(--grx-text-mute)' }}>GRX</span>
          <span style={{ color: 'var(--grx-neon)', fontWeight: 700 }}>{priceStr}</span>
        </div>
        {account
          ? <WalletChip />
          : <NeonButton onClick={connectInjected} loading={connecting} size="sm">Connect</NeonButton>}
      </div>
    </header>
  );
};

export default Header;
